
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { getCompanyName } from '@/api/company';
import { UserModule } from '@/store/user';
import { getPosts } from '@/api/irPost';
import { getUserInfo } from '@/api/user';
import type { IIrPostSummary } from '@/types/irPost';

@Component({
  name: 'IrPostList',
})
export default class extends Vue {
  private postList: IIrPostSummary[] = [];

  private currentPage = 1;

  private pageSize = 10;

  private total = 0;

  get totalPages(): number {
    return Math.ceil(this.total / this.pageSize);
  }

  private getStatusText(status: string): string {
    const statusMap: { [key: string]: string } = {
      A: '승인 대기',
      B: '답변 대기',
      C: '진행중',
      D: '관리자 반려',
      E: '투자사 거절',
      F: 'IR매칭 취소',
      S: 'IR매칭 완료',
    };
    return statusMap[status] || status;
  }

  private getStatusClass(status: string): string {
    const statusMap: { [key: string]: string } = {
      A: 'info',
      B: 'warning',
      C: 'primary',
      D: 'danger',
      E: 'danger',
      F: 'info',
      S: 'success',
    };
    return statusMap[status] || 'info';
  }

  private formatDate(date: string): string {
    return moment(date).format('YYYY-MM-DD HH:mm');
  }

  private handleRowClick(row: IIrPostSummary): void {
    if (row.status === 'A') {
      return; // Prevent navigation for '승인 대기' status
    }
    this.$router.push({
      name: 'ChatDetail',
      params: {
        menuUid: this.$route.params.menuUid,
        postUid: String(row.postId),
      },
    });
  }

  private prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage -= 1;
      this.fetchPostList();
    }
  }

  private nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage += 1;
      this.fetchPostList();
    }
  }

  private handleSizeChange(): void {
    this.currentPage = 1;
    this.fetchPostList();
  }

  private async fetchPostList(): Promise<void> {
    if (!UserModule.token) {
      alert('로그인이 필요합니다.');
      this.$router.push('/login');
      return;
    }

    try {
      const uRes = await getUserInfo();
      const { uid, roles } = uRes.data;
      console.log(uRes.data);

      if (!uid) {
        console.error('fetchPostList: 사용자 정보에서 UID를 가져올 수 없습니다.');
        return;
      }

      UserModule.setUserUid(uid);

      const isAdmin = roles && roles.includes('ROLE_ADMIN');

      const params: any = {
        page: this.currentPage - 1,
        size: this.pageSize,
        sort: 'createdDate,desc',
      };

      if (!isAdmin) {
        params.fromUserUid = uid;
      }

      const response = await getPosts(params);
      const posts = response.data.content;

      // ✅ 각 게시글의 toUserUid로 회사명 조회
      this.postList = await Promise.all(
        posts.map(async (post: IIrPostSummary) => {
          try {
            const res = await getCompanyName(post.toUserUid);
            console.log(res);
            return {
              ...post,
              companyName: res.data.coName, // 회사명 추가
            };
          } catch (error) {
            console.error(`회사 정보 조회 실패 (${post.toUserUid}):`, error);
            return {
              ...post,
              companyName: post.toUserUid, // 실패 시 UID 그대로 표시
            };
          }
        }),
      );

      this.total = response.data.totalElements;

      console.log('게시글 목록:', this.postList);
      console.log('총 개수:', this.total);
    } catch (error) {
      console.error('게시글 목록을 불러오는데 실패했습니다.', error);
    }
  }

  private async created(): Promise<void> {
    await this.fetchPostList();
  }
}
